import { httpGuestLogin } from "@/features/auth/services/guest-login";
import { getAccessToken as getAccessTokenFromApp, isInApp, isVestEnv, UserType } from "./index";
import { bridge } from "./bridge-vest";
import { GUEST_AUTO_LOGIN_OUT } from '@/const/storage-key';
import type { LoginStatusType } from "@/const/login";

export interface GuestLoginResult {
  token: string;
  loginStatus?: LoginStatusType;
}

// 获取 accessToken
// 兼容 apk和马甲包的不同版本
export const getAccessToken = async (auto?: boolean): Promise<GuestLoginResult> => {
  let token = '';
  let loginStatus: LoginStatusType | undefined;
  if (isInApp()) {
    token = await getAccessTokenFromApp();
  }
  if (!token && isVestEnv) {
    const guestLogout = !!localStorage.getItem(GUEST_AUTO_LOGIN_OUT);
    // 如果遇到游客退出登录的标记，则可以直接返回token为空
    if (!guestLogout || auto) {
      const res = await httpGuestLogin();
      loginStatus = res?.loginStatus;
      // 游客
      if ((Number(res?.loginStatus) as UserType) === UserType.Guest) {
        token = res?.accessToken || '';
      }
    }
  }
  return { token: token, loginStatus };
};

export const getAppInstanceId = (): Promise<string> => {
  return bridge.getAppInstanceId();
};

